import { render, staticRenderFns } from "./viewLoginOrSignup.vue?vue&type=template&id=0a116a17&scoped=true"
import script from "./viewLoginOrSignup.vue?vue&type=script&lang=js"
export * from "./viewLoginOrSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a116a17",
  null
  
)

export default component.exports